import { render, staticRenderFns } from "./ResourcesModal.vue?vue&type=template&id=2369a417&scoped=true"
import script from "./ResourcesModal.vue?vue&type=script&lang=ts"
export * from "./ResourcesModal.vue?vue&type=script&lang=ts"
import style0 from "./ResourcesModal.vue?vue&type=style&index=0&id=2369a417&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369a417",
  null
  
)

export default component.exports